exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "canvas[data-v-52ed1d2f]{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-52ed1d2f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/vue-components/fob-price-comparison.vue
// module id = 250
// module chunks = 0